import Vue from 'vue';
const ErrorBoundary = Vue.extend({
  name: 'ErrorBoundary',
  render(h) {
    return h('div', this.$slots.default);
  },
  template: '<div><slot></slot></di>',
  errorCaptured: (err, vm, info) => {
    console.error('ErrorBoundary Found Errors', err, info);
    return false;
  }
});
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map
